import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import {
	ActualAccrualFields,
	DeferredAccrualFields,
} from '@shared/utils/constants';
import EditableTable from '@client/components/EditableTable';
import {
	createMappingEntry,
	getUserData,
} from '@client/lib/api';
import showSuccessNotification from '@client/utils/showSuccessNotification';
import showErrorNotification from '@client/utils/showErrorNotification';

const ManualAccrualMapping = () => {
	const {
		data: userData,
		refetch: refreshUserData,
	} = useQuery(
		'userData',
		getUserData,
	);

	const onSave = async (
		field: string,
		result: { accountingCode: string | undefined },
	) => {
		const value = result.accountingCode;

		if (value != null && field != null) {
			try {
				await createMappingEntry('accrual', field, value);
				await refreshUserData();
				showSuccessNotification('Successfully mapped entry');
			} catch (e) {
				showErrorNotification('Could not create mapping', e as Error);
			}
		}
	};

	const accrualsWithCode = useMemo(() => {
		const entries = userData?.globalMappingEntries ?? [];

		const fields = { ...ActualAccrualFields, ...DeferredAccrualFields };

		const formatted = Object.keys(fields).map((key) => {
			const mappingEntry = entries.find((mapping) => (
				mapping.type === 'accrual' &&
                    mapping.cvIdentifier === String(key)
			));

			return {
				key,
				field: fields[key as keyof typeof fields],
				accountingCode: mappingEntry?.code ?? undefined,
			};
		});

		return formatted;
	}, [userData]);

	return (
		<div style={{ width: 750 }}>
			<EditableTable<{ key: string; field: string; accountingCode: string | undefined }, 'key'>
				actionsTitle=""
				iconButtons
				pagination={false}
				keyDataIndex="key"
				onSave={onSave}
				dataSource={accrualsWithCode ?? []}
				showSorterTooltip
				columns={[
					{
						key: 'fieldRow',
						dataIndex: 'field',
						title: 'Field',
					},
					{
						dataIndex: 'accountingCode',
						title: 'Accounting System Code',
						editingProps: {
							type: 'string',
							inputProps: {
								placeholder: 'Specify code',
							},
						},
						editable: true,
					},
				]}
			/>
		</div>
	);
};

export default ManualAccrualMapping;
